import DesignationOverviewPageActionTypes from './designation-overview-page-action-types';
import axios from 'axios';
import { DESIGNATION_STATUS } from '../../../resources/designationStatus';

export const loadDesignationOverviewPage = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: DesignationOverviewPageActionTypes.LOAD_DESIGNATION_OVERVIEW_PAGE_START });
  const { designationId, studyPlanId, studyPlanCycleId, studyPlanCycleStudentId, studyPlanCycleDepartmentStudentId, localizationService } = payload;
  const state = getState().designationOverviewPage;
  try {
    state.designationCancelToken?.cancel();
    state.designationCancelToken = axios.CancelToken.source();
    let designation;
    let designationDocumentPdf;
    let designationHistory;
    if (designationId) {
      designation = await api.get(`api/designation/${designationId}`, state.designationCancelToken.token);
      designationDocumentPdf = await api.get(`api/designation/${designationId}/download`, {}, state.designationCancelToken.token, 'blob');
      designationHistory = await api.get(`api/designation/${designationId}/history`, state.designationCancelToken.token);
    } else {
      const studyPlanCycleDepartmentStudent = await api.get(`api/study_plans/${studyPlanId}/cycles/${studyPlanCycleId}/students/${studyPlanCycleStudentId}/departments/${studyPlanCycleDepartmentStudentId}`);
      designation = {
        id: 0,
        studyPlanCycleDepartmentStudentId: studyPlanCycleDepartmentStudentId,
        studyPlanCycleStudentId: studyPlanCycleStudentId,
        studyPlanCycleId: studyPlanCycleId,
        studyPlanId: studyPlanId,
        cycle: studyPlanCycleDepartmentStudent.cycleName,
        department: studyPlanCycleDepartmentStudent.studyPlanCycleDepartmentName,
        accreditationDateFrom: studyPlanCycleDepartmentStudent.dateFrom,
        accreditationDateTo: studyPlanCycleDepartmentStudent.dateTo,
        accreditationCredits: studyPlanCycleDepartmentStudent.credits,
        status: studyPlanCycleDepartmentStudent.designationStatus
      };
    }
    const designationPdfFilename = localizationService.toLanguageString('designations.filenameTemplate').replace('{id}', designation.id);
    dispatch({
      type: DesignationOverviewPageActionTypes.LOAD_DESIGNATION_OVERVIEW_PAGE_END,
      payload: {
        designation: {
          ...designation,
          designationHistory: designationHistory?.data ?? [],
          designationPdfObjectUrl: designationDocumentPdf
            ? URL.createObjectURL(new File([designationDocumentPdf], designationPdfFilename, { type: 'application/pdf' }))
            : null
        }
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: DesignationOverviewPageActionTypes.LOAD_DESIGNATION_OVERVIEW_PAGE_END });
      throw error;
    }
  }
};

export const submitDesignation = (payload) => async(dispatch, getState, { api, history }) => {
  const state = getState().designationOverviewPage;
  const { studyPlanCycleDepartmentStudentId } = state.designation;
  dispatch({ type: DesignationOverviewPageActionTypes.SUBMIT_DESIGNATION_START });
  try {
    state.designationCancelToken?.cancel();
    state.designationCancelToken = axios.CancelToken.source();
    const designationId = await api.post(`api/study_plan_cycle_department_student/${studyPlanCycleDepartmentStudentId}/designation_submit`);
    dispatch({ type: DesignationOverviewPageActionTypes.SUBMIT_DESIGNATION_END });
    if (designationId > 0) {
      history.replace(`/designations/${designationId}/overview`);
      dispatch(loadDesignationOverviewPage({ designationId, localizationService: payload.localizationService }));
    }
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: DesignationOverviewPageActionTypes.SUBMIT_DESIGNATION_END });
      throw error;
    }
  }
};

export const approveDesignation = () => async(dispatch, getState, { api }) => {
  const state = getState().designationOverviewPage;
  const designation = state.designation;
  dispatch({ type: DesignationOverviewPageActionTypes.APPROVE_DESIGNATION_START });
  try {
    state.designationCancelToken?.cancel();
    state.designationCancelToken = axios.CancelToken.source();
    await api.post(`api/designation/${state.designation.id}/approve`, state.designationCancelToken.token);
    const designationHistory = await api.get(`api/designation/${state.designation.id}/history`, state.designationCancelToken.token);
    dispatch({
      type: DesignationOverviewPageActionTypes.APPROVE_DESIGNATION_END,
      payload: {
        designation: {
          ...designation,
          designationHistory: designationHistory.data ?? [],
          status: DESIGNATION_STATUS.APPROVED
        }
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: DesignationOverviewPageActionTypes.APPROVE_DESIGNATION_END });
      throw error;
    }
  }
};

export const unapproveDesignation = () => async(dispatch, getState, { api }) => {
  const state = getState().designationOverviewPage;
  const designation = state.designation;
  dispatch({ type: DesignationOverviewPageActionTypes.UNAPPROVE_DESIGNATION_START });
  try {
    state.designationCancelToken?.cancel();
    state.designationCancelToken = axios.CancelToken.source();
    await api.post(`api/designation/${state.designation.id}/unapprove`, state.designationCancelToken.token);
    const designationHistory = await api.get(`api/designation/${state.designation.id}/history`, state.designationCancelToken.token);
    dispatch({
      type: DesignationOverviewPageActionTypes.APPROVE_DESIGNATION_END,
      payload: {
        designation: {
          ...designation,
          designationHistory: designationHistory.data ?? [],
          status: DESIGNATION_STATUS.FORMED
        }
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: DesignationOverviewPageActionTypes.UNAPPROVE_DESIGNATION_END });
      throw error;
    }
  }
};

export const cleanupDesignationOverviewPage = () => async(dispatch, getState) => {
  const state = getState().designationOverviewPage;
  URL.revokeObjectURL(state.designation?.designationPdfObjectUrl);
  dispatch({ type: DesignationOverviewPageActionTypes.CLEANUP_DESIGNATION_OVERVIEW_PAGE });
};

export const toggleDesignationOverviewConfirmDialog = (payload) => async(dispatch) => {
  dispatch({ type: DesignationOverviewPageActionTypes.TOGGLE_DESIGNATION_CONFIRM_DIALOG, payload });
};

export const resubmitDesignation = (payload) => async(dispatch, getState, { api }) => {
  const state = getState().designationOverviewPage;
  dispatch({ type: DesignationOverviewPageActionTypes.RESUBMIT_DESIGNATION_START });
  try {
    state.designationCancelToken?.cancel();
    state.designationCancelToken = axios.CancelToken.source();
    await api.post(`api/study_plan_cycle_department_student/${state.designation.studyPlanCycleDepartmentStudentId}/designation_submit`, state.designationCancelToken.token);
    dispatch({ type: DesignationOverviewPageActionTypes.RESUBMIT_DESIGNATION_END });
    dispatch(loadDesignationOverviewPage({ designationId: state.designation.id, localizationService: payload.localizationService }));
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: DesignationOverviewPageActionTypes.RESUBMIT_DESIGNATION_END });
      throw error;
    }
  }
};

export const removeDesignation = () => async(dispatch, getState, { api, history }) => {
  const state = getState().designationOverviewPage;
  dispatch({ type: DesignationOverviewPageActionTypes.REMOVE_DESIGNATION_START });
  try {
    state.designationCancelToken?.cancel();
    state.designationCancelToken = axios.CancelToken.source();
    await api.remove(`api/designation/${state.designation.id}/remove`, state.designationCancelToken.token);
    dispatch({ type: DesignationOverviewPageActionTypes.REMOVE_DESIGNATION_END });
    history.replace('/designations');
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: DesignationOverviewPageActionTypes.REMOVE_DESIGNATION_END });
      throw error;
    }
  }
};

export const cancelDesignation = (payload) => async(dispatch, getState, { api }) => {
  const state = getState().designationOverviewPage;
  const { localizationService } = payload;
  dispatch({ type: DesignationOverviewPageActionTypes.CANCEL_DESIGNATION_START });
  try {
    state.designationCancelToken?.cancel();
    state.designationCancelToken = axios.CancelToken.source();
    await api.post(`api/designation/${state.designation.id}/cancel`, state.designationCancelToken.token);
    const designationHistory = await api.get(`api/designation/${state.designation.id}/history`, state.designationCancelToken.token);
    dispatch({
      type: DesignationOverviewPageActionTypes.CANCEL_DESIGNATION_END,
      payload: {
        designation: {
          ...state.designation,
          designationHistory: designationHistory.data ?? [],
          status: DESIGNATION_STATUS.CANCELLED
        },
        successMessage: localizationService.toLanguageString('designations.cancellationEmailSentSuccessfully')
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({
        type: DesignationOverviewPageActionTypes.CANCEL_DESIGNATION_END,
        payload: {
          errorMessage: error.message
        }
      });
    }
  }
};
